(() => {
  const money = (cents, currency='INR') => {
    try { return new Intl.NumberFormat('en-IN',{style:'currency',currency,maximumFractionDigits:0}).format((Number(cents)||0)/100); }
    catch(e){ return '₹' + Math.round((Number(cents)||0)/100); }
  };
  const init = (root) => {
    if (!root || root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    const currency = root.dataset.currency || 'INR';
    let variantId = root.dataset.variantId;
    let variantPrice = Number(root.dataset.variantPrice || 0);
    let quantity = 1;

    const $ = (s, ctx=root) => ctx.querySelector(s);
    const $$ = (s, ctx=root) => [...ctx.querySelectorAll(s)];

    // Drain Cleaner and Shree Yantra: rolling example dates in India time; other products stay unchanged.
    if (['10340380541043','10377480994931'].includes(String(root.dataset.productId))) {
      const indiaDateFormat = new Intl.DateTimeFormat('en-GB', {timeZone:'Asia/Kolkata',day:'numeric',month:'short'});
      const dateParts = (base, offset) => {
        const parts = indiaDateFormat.formatToParts(new Date(base + offset * 86400000));
        return {day:parts.find(p=>p.type==='day')?.value,month:parts.find(p=>p.type==='month')?.value};
      };
      const renderDates = () => {
        const base = Date.now();
        const order = dateParts(base,0), shipStart = dateParts(base,1),
              shipEnd = dateParts(base,2), delivery = dateParts(base,5);
        const dayMonth = d => d.day + ' ' + d.month;
        const shipRange = shipStart.month === shipEnd.month
          ? shipStart.day + '–' + shipEnd.day + ' ' + shipEnd.month
          : dayMonth(shipStart) + '–' + dayMonth(shipEnd);
        $('[data-mp-order-date]') && ($('[data-mp-order-date]').textContent=dayMonth(order));
        $('[data-mp-ship-date]') && ($('[data-mp-ship-date]').textContent=shipRange);
        $('[data-mp-delivery-date]') && ($('[data-mp-delivery-date]').textContent=dayMonth(delivery));
      };
      renderDates();
      window.setInterval(renderDates, 60000);
    } else {
      // Preserve all other products' existing timeline behavior.
      $('[data-mp-order-date]') && ($('[data-mp-order-date]').textContent='4 Oct');
      $('[data-mp-ship-date]') && ($('[data-mp-ship-date]').textContent='5–6 Oct');
      $('[data-mp-delivery-date]') && ($('[data-mp-delivery-date]').textContent='9 Oct');
    }

    // Countdown is initialized from the reusable shared timer snippet.

    // Gallery
    $$('[data-mp-thumb]').forEach(btn => btn.addEventListener('click', () => {
      const idx = btn.dataset.mpThumb;
      $$('[data-mp-thumb]').forEach(x=>x.classList.toggle('is-active',x===btn));
      $$('[data-mp-slide]').forEach(x=>x.classList.toggle('is-active',x.dataset.mpSlide===idx));
    }));
    $('[data-mp-share]')?.addEventListener('click', async () => {
      try { if (navigator.share) await navigator.share({title:document.title,url:location.href}); else { await navigator.clipboard.writeText(location.href); } } catch(e){}
    });

    // Variant select
    $('[data-mp-variant-select]')?.addEventListener('change', (e) => {
      const opt = e.target.options[e.target.selectedIndex];
      variantId = opt.value;
      variantPrice = Number(opt.dataset.price || variantPrice);
      root.dataset.variantId = variantId;
      root.dataset.variantPrice = variantPrice;
      const nativeVariantInput = $('[data-mp-native-variant-id]');
      if (nativeVariantInput) nativeVariantInput.value = variantId;
      $('[data-mp-price]').forEach(el=>el.textContent=money(variantPrice,currency));
      $$('[data-mp-bundle-total]').forEach(el=>el.textContent=money(variantPrice*Number(el.dataset.qty||1),currency));
    });

    // Bundles / quantity
    $$('[data-mp-bundle]').forEach(btn => btn.addEventListener('click', () => {
      quantity = Number(btn.dataset.qty || 1);
      const nativeQuantityInput = $('[data-mp-native-quantity]');
      if (nativeQuantityInput) nativeQuantityInput.value = quantity;
      $('[data-mp-bundle]').forEach(x=>x.classList.toggle('is-selected',x===btn));
    }));

    // Scenario tabs
    $$('[data-mp-scenario-tab]').forEach(btn => btn.addEventListener('click', () => {
      const idx = btn.dataset.mpScenarioTab;
      $$('[data-mp-scenario-tab]').forEach(x=>x.classList.toggle('is-active',x===btn));
      $$('[data-mp-scenario-panel]').forEach(x=>x.classList.toggle('is-active',x.dataset.mpScenarioPanel===idx));
    }));

    // Scroll buy
    $$('[data-mp-scroll-buy]').forEach(btn => btn.addEventListener('click', () => {
      $('#upe-mp-primary-cta')?.scrollIntoView({behavior:'smooth',block:'center'});
    }));

    // Sticky CTA after main CTA leaves viewport
    const sticky = $('[data-mp-sticky]');
    const primary = $('#upe-mp-primary-cta');
    if (sticky && primary && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:.02});
      io.observe(primary);
    }

    // Video modal
    const videoModal = $('[data-mp-video-modal]');
    const setVideo = (open) => {
      if(!videoModal) return;
      videoModal.classList.toggle('is-open',open); videoModal.setAttribute('aria-hidden',open?'false':'true');
      if(!open) videoModal.querySelector('video')?.pause();
    };
    $$('[data-mp-open-video]').forEach(b=>b.addEventListener('click',()=>setVideo(true)));
    $$('[data-mp-close-video]').forEach(b=>b.addEventListener('click',()=>setVideo(false)));

    // Cart drawer
    const cart = $('[data-mp-cart]');
    const openCart = () => { cart?.classList.add('is-open'); cart?.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; refreshCart(); };
    const closeCart = () => { cart?.classList.remove('is-open'); cart?.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; };
    $$('[data-mp-open-cart]').forEach(b=>b.addEventListener('click',openCart));
    $$('[data-mp-close-cart]').forEach(b=>b.addEventListener('click',closeCart));

    const refreshCart = async () => {
      try {
        const r = await fetch('/cart.js',{headers:{'Accept':'application/json'}}); const c = await r.json();
        $$('[data-mp-cart-count]').forEach(x=>x.textContent=c.item_count);
        $('[data-mp-drawer-count]') && ($('[data-mp-drawer-count]').textContent=`${c.item_count} item${c.item_count===1?'':'s'}`);
        $('[data-mp-cart-subtotal]') && ($('[data-mp-cart-subtotal]').textContent=money(c.total_price,currency));
        const wrap = $('[data-mp-cart-items]'); if(!wrap) return;
        if(!c.items.length){wrap.innerHTML='<p class="upe-mp-cart-empty">Your cart is empty.</p>';return;}
        wrap.innerHTML=c.items.map((it,i)=>`<div class="upe-mp-cart-item" data-line="${i+1}"><img src="${it.image||''}" alt=""><div><h4>${it.product_title}</h4><p>${it.variant_title && it.variant_title!=='Default Title'?it.variant_title:''}</p><div class="upe-mp-cart-item__bottom"><div class="upe-mp-qty"><button type="button" data-mp-qty-minus>−</button><span>${it.quantity}</span><button type="button" data-mp-qty-plus>+</button></div><strong>${money(it.final_line_price,currency)}</strong><button class="upe-mp-remove" type="button" data-mp-remove>Remove</button></div></div></div>`).join('');
        $$('[data-line]',wrap).forEach(row=>{
          const line=Number(row.dataset.line), qty=Number(row.querySelector('.upe-mp-qty span')?.textContent||1);
          row.querySelector('[data-mp-qty-minus]')?.addEventListener('click',()=>changeLine(line,Math.max(0,qty-1)));
          row.querySelector('[data-mp-qty-plus]')?.addEventListener('click',()=>changeLine(line,qty+1));
          row.querySelector('[data-mp-remove]')?.addEventListener('click',()=>changeLine(line,0));
        });
      } catch(e) {}
    };
    const changeLine = async (line,qty) => {
      try { await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity:qty})}); await refreshCart(); }
      catch(e){}
    };
    const add = async (goCheckout=false) => {
      const btn = goCheckout ? $('[data-mp-buy-now]') : $('[data-mp-add-cart]');
      if(btn) btn.disabled=true;
      try {
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(String(variantId).split('/').pop()),quantity}]})});
        if(!r.ok) throw new Error('add failed');
        if(goCheckout){ location.href='/checkout'; return; }
        await refreshCart(); openCart();
      } catch(e) { alert('Could not add this item. Please refresh and try again.'); }
      finally { if(btn) btn.disabled=false; }
    };
    $('[data-mp-add-cart]')?.addEventListener('click',()=>add(false));
    $('[data-mp-buy-now]')?.addEventListener('click',()=>add(true));
    refreshCart();
  };
  const boot=()=>document.querySelectorAll('[data-upe-mp]').forEach(init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
